const didomiReadyEventName = 'didomiIsReady';
let didomiReadyDispatched = false;

/**
 * Dispatches the centralized Didomi readiness signal exactly once.
 *
 * The first successful call stores readiness state on window so scripts
 * that initialize later can still detect consent bootstrap completion.
 * It also forwards context metadata through the custom event detail payload.
 */
function dispatchDidomiReadyEvent(eventDetail) {
    if (didomiReadyDispatched) {
        return;
    }

    didomiReadyDispatched = true;
    window.didomiReady = true;
    window.didomiReadyDetail = eventDetail || {};

    window.dispatchEvent(new window.CustomEvent(didomiReadyEventName, {
        detail: window.didomiReadyDetail
    }));
}

window.didomiOnReady = window.didomiOnReady || [];
window.didomiOnReady.push(function () {
    if (typeof window.__tcfapi !== 'function') {
        dispatchDidomiReadyEvent({
            source: 'didomiOnReady',
            tcfapiAvailable: false
        });
        return;
    }

    window.__tcfapi('ping', 2, function (pingData, pingSuccess) {
        dispatchDidomiReadyEvent({
            source: 'didomiOnReady',
            tcfapiAvailable: true,
            pingSuccess: !!pingSuccess,
            gdprApplies: pingData ? pingData.gdprApplies : null,
            cmpStatus: pingData ? pingData.cmpStatus : null
        });
    });
});

/**
 * Initializes Didomi preferences UI behavior after page load.
 * Waits briefly for the Didomi SDK to become available,
 * reveals the sticky preferences trigger, and binds click
 * handlers that open the Didomi preferences modal.
 */
function initDidomiPreferences() {
    const didomiButtons = document.querySelectorAll('.js_didomiPreferences');
    const didomiSticky = document.querySelector('.js_stickyDidomi');

    setTimeout(function () {
        if (typeof window.Didomi === 'object') {
            if (didomiSticky) {
                didomiSticky.classList.remove('hidden');
            }

            for (const button of didomiButtons) {
                button.addEventListener('click', function (event) {
                    event.preventDefault();
                    window.Didomi.preferences.show();
                });
            }
        }
    }, 3000);
}

document.addEventListener('DOMContentLoaded', initDidomiPreferences);
